export default __webpack_public_path__ + "static/media/logo_p_small.e27c608f.png";